import React from 'react';
import { Helmet } from 'react-helmet-async';
import {
  Card,
  Stack,
  Button,
  Container,
  Typography,
} from '@mui/material';
import { Link } from 'react-router-dom';
import Iconify from '../component/iconify';
import Scrollbar from '../component/scrollbar';
import GetDechargements from '../component/dechargement/GetDechargements';

export default function DechargementPage() {
  return (
    <>
      <Helmet>
        <title>Déchargements</title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Déchargements
          </Typography>
          <Button component={Link} to="/dashboard/ajoutdechargement" variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            Nouveau
          </Button>
        </Stack>

        <Card>
          <Scrollbar>
            <GetDechargements />
          </Scrollbar>
        </Card>
      </Container>
    </>
  );
}
